import ProfilePage from '../pages/ProfilePage/index';
import CompanyPage from '../pages/CompanyPage/index';
import WelcomePage from '../pages/WelcomePage/index';
import AccountSettings from '../pages/AccountSettings';
import NewslettersPage from '../pages/NewsLettersPage/index';
import CompanyAdminDashboardPage from '../pages/CompanyAdmin/Dashboard';
import CompanyAdminUsersPage from '../pages/CompanyAdmin/Users';
import CoursesPage from '../pages/CoursesPage';
import DevicesPage from '../pages/DevicesPage';

import { END_USERS_ROLE, PROFESSIONAL_USER_ROLE } from '../utils/constants';
import UserActivitiesPage from '../pages/UserActivitiesPage';

export const PATH_NAMES = {
  welcome: '/welcome',
  profile: '/',
  company: '/company',
  accountSettings: '/account_settings',
  devices: '/devices',
  userActivities: '/user_activities',
  newsletters: '/newsletters',
  company_admin: '/company_admin',
  company_admin_users: '/company_users',
  courses: '/courses',
};

const routes = [
  {
    path: PATH_NAMES.welcome,
    component: WelcomePage,
    exact: true,
    available: [PROFESSIONAL_USER_ROLE],
  },
  {
    path: PATH_NAMES.profile,
    component: ProfilePage,
    exact: true,
    available: [END_USERS_ROLE, PROFESSIONAL_USER_ROLE],
  },
  {
    path: PATH_NAMES.company,
    component: CompanyPage,
    exact: false,
    available: [PROFESSIONAL_USER_ROLE],
  },
  {
    path: PATH_NAMES.accountSettings,
    component: AccountSettings,
    exact: false,
    available: [END_USERS_ROLE, PROFESSIONAL_USER_ROLE],
  },
  {
    path: PATH_NAMES.devices,
    component: DevicesPage,
    exact: false,
    available: [END_USERS_ROLE],
  },
  {
    path: PATH_NAMES.userActivities,
    component: UserActivitiesPage,
    exact: false,
    available: [END_USERS_ROLE],
  },
  {
    path: PATH_NAMES.newsletters,
    component: NewslettersPage,
    exact: false,
    available: [END_USERS_ROLE, PROFESSIONAL_USER_ROLE],
  },
  {
    path: PATH_NAMES.company_admin,
    component: CompanyAdminDashboardPage,
    exact: false,
    available: [PROFESSIONAL_USER_ROLE],
  },
  {
    path: PATH_NAMES.company_admin_users,
    component: CompanyAdminUsersPage,
    exact: false,
    available: [PROFESSIONAL_USER_ROLE],
  },
  {
    path: PATH_NAMES.courses,
    component: CoursesPage,
    exact: false,
    available: [PROFESSIONAL_USER_ROLE],
  },
];

export default routes;
